import * as React from 'react';
import { SVGProps } from 'react';

const IconAttachSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.579 10.78a3.999 3.999 0 0 1-5.657 0 3.999 3.999 0 0 1 0-5.657L6.165.88a2.996 2.996 0 0 1 4.242 0 2.996 2.996 0 0 1 0 4.243L6.165 9.366a2.006 2.006 0 0 1-2.829 0 2.006 2.006 0 0 1 0-2.829L7.58 2.295l.707.707-4.243 4.242a1.003 1.003 0 0 0 0 1.415 1.003 1.003 0 0 0 1.415 0L9.7 4.416a2.006 2.006 0 0 0 0-2.829 2.006 2.006 0 0 0-2.828 0L2.629 5.83a2.996 2.996 0 0 0 0 4.243 2.996 2.996 0 0 0 4.243 0l3.535-3.536.707.707L7.58 10.78z" />
  </svg>
);
export default IconAttachSizeXs;
